import { Dialog, useTheme } from '@mui/material';
import { AlignButtons, AlignLeft, Container } from 'v3/shared/components/Modal/AssureModal/styles';
import { IModalProps } from 'v3/shared/components/Modal/AssureModal/types';
import { BodyLarge } from 'v3/shared/typography/BodyLarge';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { TextButton } from '../../Button/TextButton';

export const AssureModal: React.FC<IModalProps> = ({ modal, onClose, onConfirm }) => {
  const theme = useTheme();

  return (
    <Dialog
      onClose={onClose}
      open={modal.active}
      aria-labelledby="customized-dialog-title"
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          maxWidth: '30rem',
        },
      }}
    >
      <Container>
        <AlignLeft>
          <BodyLarge>{modal.title}</BodyLarge>
          <SubtitleLarge color={theme.palette.info.main}>{modal.subtitle}</SubtitleLarge>
        </AlignLeft>
        <AlignButtons>
          {modal.activeButton && (
            <TextButton
              textColor={theme.palette.tertiary.main}
              text={modal.agreeButton}
              handleClick={() => {
                onConfirm();
              }}
            />
          )}
          {modal.activeButton && <TextButton text={modal.disagreeButton} handleClick={onClose} />}
        </AlignButtons>
      </Container>
    </Dialog>
  );
};
